import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const AirportWestPage = () => <LocationTemplate suburbName="Airport West" suburbSlug="airport-west" />;

export default AirportWestPage;
